//Seccion de los pasos para la pasarela de pagos 

import React, { useEffect, useMemo, useState } from "react";
import BreadCrumbsGeneric from "../../components/Nav/BreadCrumbsGeneric";
import { useLocation } from "react-router-dom";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import StepsGeneric from "../../components/Nav/StepsGeneric";
import Step5 from "./Steps/Step5";

function BillDetails({ path }) {
  //Te indica en que rutas estas actualmente
  const location = useLocation();
  const pathName = location.pathname;
  const [deatils, setDeatils] = useState(null);

  //Estado que guarda la informacion solicitada de todos los pasos
  const [stespData, setStespData] = useState("");


  //Estados para el seguimiento de pasos para la pasarela de pagos
  const [stapsState, setStapsState] = useState({
    option1: true,
    option2: false,
    option3: false,
    option4: false,
    option5: false,
  });
  // Step1 Vista para la seleccion de moneda
  // Step2 Vista para ingresar el monto a pagar
  // Step3 Vista para la seleccion para el metodo de pago  
  // Step4 Vista de metodo de pago, para ingresar los datos solicitados
  // Step5 Vista de confirmacion de pago


  useEffect(() => {
    setDeatils(location?.state?.data);
  }, [location]);

  return (
    <>
      <>
        <div className=" relative bg-[#f3f4f6]">
          <div className="flex max-w-7xl mx-auto  pt-6 justify-center">
            <div className="flex w-full lg:w-full px-4 pt-5 gap-5 flex-col">
              {/*   Recibe la navegacion que te indica en que ruta estas */}
              <BreadCrumbsGeneric locations={pathName} />
              <div className="bg-white  rounded-md shadow">
                {/*   Recibe el stapsState para el estado del seguimiento de los pasos*/}
                <StepsGeneric stateSteps={stapsState} />
              </div>
              <div className="bg-white  rounded-md shadow mb-[100px]">
                <div className=" flex justify-center items-center flex-col gap-6 ">
                  {stapsState.option1 && (
                    <>
                      <Step1
                        stapsState={stapsState}
                        setStapsState={setStapsState}
                        deatils={deatils}
                        setStespData={setStespData}
                        stespData={stespData}
                      />
                    </>
                  )}
                  {stapsState.option2 && (
                    <>
                      <Step2
                        stapsState={stapsState}
                        setStapsState={setStapsState}
                        deatils={deatils}
                        setStespData={setStespData}
                        stespData={stespData}
                      />
                    </>
                  )}
                  {stapsState.option3 && (
                    <>
                      <Step3
                        stapsState={stapsState}
                        setStapsState={setStapsState}
                        deatils={deatils}
                        setStespData={setStespData}
                        stespData={stespData}
                      />
                    </>
                  )}
                  {stapsState.option4 && (
                    <>
                      <Step4
                        stapsState={stapsState}
                        setStapsState={setStapsState}
                        deatils={deatils}
                        setStespData={setStespData}
                        stespData={stespData}
                      />
                    </>
                  )}
                  {stapsState.option5 && (
                    <>
                      <Step5
                        stapsState={stapsState}
                        setStapsState={setStapsState}
                        deatils={deatils}
                        setStespData={setStespData}
                        stespData={stespData}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
}

export default BillDetails;
